import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';


@Injectable({ providedIn: 'root' })
export class ClipboardService {
  constructor(private messageService: MessageService) {}
  copy(text: string, label = 'Copied to clipboard'): void {
    navigator.clipboard.writeText(text).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: label,
        life: 2000,
      });
    });
  }
}
